import { render, staticRenderFns } from "./QACompare.vue?vue&type=template&id=3af970b2"
import script from "./QACompare.vue?vue&type=script&lang=js"
export * from "./QACompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports